import {
    GenericLink,
    GenericLinkGroups,
    LinkFooterAssemblyModel,
    LinkFooterModel,
    FooterModelType
} from '../../../types/footer';

type FooterLinkWithIcon = LinkFooterModel & {
    icon_dm?: {
        damUrl?: string;
    };
};

export function mapFooterDataToProps(footerData: FooterModelType) {
    const contactLinksEntry =
        (footerData.contactLinks as LinkFooterAssemblyModel[] | undefined)?.[0] ??
        (footerData.contactLinks as LinkFooterAssemblyModel | undefined);

    return {
        copyright: footerData.copyright,
        linkGroupProps: mapLinkGroups(footerData.links as LinkFooterAssemblyModel[] | undefined),
        vision: footerData.description,
        brandLogoProps: {
            ariaLabel: 'Vodafone Home',
            url: '/'
        },
        contactLinksProps: {
            links: mapLinksWithIcons(contactLinksEntry?.links as LinkFooterModel[] | undefined),
            title: contactLinksEntry?.label ?? ''
        },
        socialLinksProps: {
            links: mapLinksWithIcons(footerData.socialLinks as LinkFooterModel[] | undefined),
            title: footerData.socialLinksTitle ?? ''
        },
        quickLinks: mapQuickLinks(footerData.bottomPageLinks as LinkFooterModel[] | undefined)
    };
}

function mapLinkGroups(links: LinkFooterAssemblyModel[] | undefined): GenericLinkGroups {
    return (links ?? []).reduce((acc: GenericLinkGroups, group: LinkFooterAssemblyModel) => {
        const groupTitle = group.label;
        const groupLinks: GenericLink[] = mapGenericLinks(group.links as LinkFooterModel[] | undefined);

        if (groupTitle) {
            acc[groupTitle] = groupLinks;
        }

        return acc;
    }, {});
}

function mapGenericLinks(links: LinkFooterModel[] | undefined): GenericLink[] {
    return (links ?? []).map((link: LinkFooterModel) => ({
        label: link.label ?? '',
        url: link.url ?? '/'
    }));
}

function mapLinksWithIcons(links: LinkFooterModel[] | undefined) {
    return (links ?? []).map((link: FooterLinkWithIcon) => ({
        ariaLabel: link.label,
        iconSrc: link.icon_dm?.damUrl,
        label: link.label,
        url: link.url ?? '/',
        name: link.name
    }));
}

function mapQuickLinks(links: LinkFooterModel[] | undefined) {
    return (links ?? []).map((link: LinkFooterModel) => ({
        label: link.label ?? link.name ?? '',
        url: link.url ?? '/',
        target: link.browserContext,
        name: link.name
    }));
}
